export default "__VITE_ASSET__Bbez2v1Z__"